module.exports = __webpack_public_path__ + "static/media/worker5.363affcb.jpg";